import { Eye, EyeSlash } from '@gravity-ui/icons';
import type { TextInputProps } from '@gravity-ui/uikit';
import { Button, Icon } from '@gravity-ui/uikit';

import { HIDE, SHOW } from '../constants';

export const EyeButton = (props: {
	size?: TextInputProps['size'];
	opened?: boolean;
	disabled?: boolean;
	onClick: () => void;
}) => {
	const { size = 'l', disabled, opened, onClick } = props;

	return (
		<Button
			size={size}
			view="flat"
			disabled={disabled}
			onClick={onClick}
			extraProps={{ 'aria-label': opened ? SHOW : HIDE }}
		>
			<Icon data={opened ? EyeSlash : Eye} />
		</Button>
	);
};
